import moment from 'moment';

export function DateDisplay({ order, canceled }: any) {
  const plannedDate = order.planned_shipment_date;
  const actualDate = order.real_shipment_date;

  let content: string;
  let color: string;

  if (canceled) {
    return <p style={{ color: 'red' }}>Заказ отменен</p>;
  }

  if (actualDate) {
    content = `Отправлено ${moment(plannedDate).local().format('DD.MM.YYYY')}`;
    color = 'green';
  } else if (plannedDate) {
    content = `Планируем отправить ${moment(plannedDate).local().format('DD.MM.YYYY')}`;
    color = '#FFA500';
  } else {
    content = 'Информация скоро будет';
    color = 'gray';
  }

  return <p style={{ color }}>{content}</p>;
}
